import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TicketComment, TicketCommentId} from "@shared/services";
import {User} from "@app/layout/admin/services/api/user-interfaces";
import {SiteInfo} from "@shared/services/api/access-sites.interface";
import {AppConstants} from "@shared/util/app-constants";
import {UserProfileService} from "@shared/services/api/user-profile.service";
import {PermissionId} from "@app/layout/admin/services/api/permission-interfaces";

@Component({
  selector: 'app-ticket-comment',
  templateUrl: './ticket-comment.component.html',
  styleUrl: './ticket-comment.component.scss',
  standalone: false
})
export class TicketCommentComponent implements OnInit, OnChanges {
  @Input() site: SiteInfo;
  @Input() comment: TicketComment;
  @Input() allowEdit: boolean = true;
  @Input() assigneesByEmail: Map<string, User>;
  @Output() editComment = new EventEmitter<TicketCommentId>();

  readonly DEFAULT_LOGO_CONTAINER_WIDTH = AppConstants.DEFAULT_LOGO_CONTAINER_WIDTH;
  readonly TIMESTAMP_FORMAT = AppConstants.TIME_FORMAT_SECOND_PRECISION;

  canEditComment: boolean;

  constructor(private userProfileService: UserProfileService) {
  }

  ngOnInit() {
    this.enforceCommentInput();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.comment || changes.allowEdit) {
      this.enforceCommentInput();
      const loggedInUser = this.userProfileService.getLoggedInUser();
      this.canEditComment = this.allowEdit
        && loggedInUser
        && (this.comment.author_id === loggedInUser.userId || loggedInUser.isPlatformAdmin() || loggedInUser.hasPermissionOnUserEntity(PermissionId.CUSTOMER_ADMIN));
    }
  }

  onEdit(commentId: TicketCommentId): void {
    this.editComment.emit(commentId);
  }

  private enforceCommentInput(): void {
    if (!this.comment) {
      throw new Error('comment needs to be provided.')
    }
  }
}
